// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SortColumnV1APIModel
 */
export interface SortColumnV1APIModel {
    /**
     * 
     * @type {string}
     * @memberof SortColumnV1APIModel
     */
    col: string;
    /**
     * 
     * @type {boolean}
     * @memberof SortColumnV1APIModel
     */
    asc: boolean;
}

export function SortColumnV1APIModelFromJSON(json: any): SortColumnV1APIModel {
    return SortColumnV1APIModelFromJSONTyped(json, false);
}

export function SortColumnV1APIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SortColumnV1APIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'col': json['col'],
        'asc': json['asc'],
    };
}

export function SortColumnV1APIModelToJSON(value?: SortColumnV1APIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'col': value.col,
        'asc': value.asc,
    };
}


